import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChecks = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#c1cdd1",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "DocumentType",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Checks",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					id: "Rectangle 15221",
					x: .5,
					y: 3,
					width: 15,
					height: 10,
					rx: 1,
					fill: "currentColor",
					fillOpacity: .25,
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("rect", {
					id: "Rectangle 16661",
					x: 2.66406,
					y: 5.22986,
					width: 7.80664,
					height: 1,
					rx: .5,
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("rect", {
					id: "Rectangle 16664",
					x: 2.66406,
					y: 7.375,
					width: 4.29932,
					height: 1,
					rx: .5,
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("rect", {
					id: "Rectangle 16662",
					x: 11.9902,
					y: 9.52319,
					width: 1.5,
					height: 1.5,
					rx: .75,
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("rect", {
					id: "Rectangle 16663",
					x: 9.66724,
					y: 9.52319,
					width: 1.5,
					height: 1.5,
					rx: .75,
					fill: "currentColor"
				})
			]
		})
	})
});
export default SvgChecks;
